import React, { Component } from "react";
import CenterLayout from "../../layout/center/CenterLayout";
import AbsoluteLayout from "../../layout/AbsoluteLayout";

export default class CardLayoutDemo extends Component {
  render() {
    return (
      <AbsoluteLayout>
        <AbsoluteLayout.Item
          left={100}
          right={300}
          top={200}
          height={200}
          className="bg1"
        >
          Absolute
        </AbsoluteLayout.Item>
      </AbsoluteLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.absoluteLayout.js